import { useScrollReveal } from '../hooks/useScrollReveal';

const BEFORE_1 = "https://customer-assets.emergentagent.com/job_3024c52e-4cee-4083-aea4-e49427d8ac34/artifacts/5gmsoxpx_IMG_3761.jpeg";
const AFTER_1 = "https://customer-assets.emergentagent.com/job_3024c52e-4cee-4083-aea4-e49427d8ac34/artifacts/ivg125e7_IMG_3764.jpeg";
const BEFORE_2 = "https://customer-assets.emergentagent.com/job_3024c52e-4cee-4083-aea4-e49427d8ac34/artifacts/v4u32ini_IMG_3611.jpeg";
const AFTER_2 = "https://customer-assets.emergentagent.com/job_3024c52e-4cee-4083-aea4-e49427d8ac34/artifacts/eawnpiwr_IMG_3617.jpeg";

const Pair = ({ before, after, label }) => (
  <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
    <div className="flex-1 text-center">
      <div className="relative rounded-xl overflow-hidden shadow-md aspect-square">
        <img src={before} alt={label + ' before'} className="w-full h-full object-cover" loading="lazy" />
        <span className="absolute top-3 left-3 bg-red-500/90 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">Before</span>
      </div>
    </div>
    <div className="flex-1 text-center">
      <div className="relative rounded-xl overflow-hidden shadow-md aspect-square border-2 border-[#4CAF50]">
        <img src={after} alt={label + ' after'} className="w-full h-full object-cover" loading="lazy" />
        <span className="absolute top-3 left-3 bg-[#4CAF50]/90 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">After</span>
      </div>
    </div>
  </div>
);

export const BeforeAfterGallery = ({ title, subtitle, compact }) => {
  const ref = useScrollReveal();

  return (
    <section
      ref={ref}
      className={compact ? '' : 'py-14 sm:py-20 bg-[#FAFAFA]'}
      data-testid="before-after-section"
    >
      <div className={compact ? '' : 'container mx-auto px-4 sm:px-6'}>
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 sm:mb-10 reveal">
            <h2
              className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F172A] mb-3"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {title || 'Before & After'}
            </h2>
            {subtitle && (
              <p className="text-[#555] text-sm sm:text-base max-w-xl mx-auto">{subtitle}</p>
            )}
          </div>

          <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
            <div className="reveal reveal-delay-1">
              <p className="text-center text-sm font-semibold text-[#334155] mb-3 uppercase tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>Window Track Cleaning</p>
              <Pair before={BEFORE_1} after={AFTER_1} label="Window track" />
            </div>
            <div className="reveal reveal-delay-2">
              <p className="text-center text-sm font-semibold text-[#334155] mb-3 uppercase tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>Window Sill Cleaning</p>
              <Pair before={BEFORE_2} after={AFTER_2} label="Window sill" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
